"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseInsensitiveAlphaSort = void 0;
/**
 * Can be used as a custom sort function in React Table.
 * @param rowA
 * @param rowB
 * @param columnId
 * @returns {number}
 */
var caseInsensitiveAlphaSort = function (rowA, rowB, columnId) {
    var a = rowA.values[columnId];
    var b = rowB.values[columnId];
    var aLowercase = a.toLowerCase();
    var bLowercase = b.toLowerCase();
    if (aLowercase < bLowercase) {
        return -1;
    }
    return 1;
};
exports.caseInsensitiveAlphaSort = caseInsensitiveAlphaSort;
